module.exports = __webpack_public_path__ + "media/images/my_apps/muscles 7_app icon_rounded_115-e7edede7f5c7f220b05cc66e0be99318.png";